import React, { Fragment, useEffect, useState } from 'react';
import { useViewChangeTracker } from '../../../hooks/useViewChangeTracker';

import HeatmapChart from '../Charts/Heatmap/HeatmapChart';
import LineChart from '../Charts/Line/LineChart';
import NetworkChart from '../Charts/Network/NetworkChart';

function getInitialChartInfo(selectedChart) {
  return {
    type: selectedChart,
    variable: 'score',
    variableName: 'GDA Score',
    variableFullName: 'GDA Score',
  };
}

function SummaryGDAGraphs({ source, keySearch, view, names, selectedChart }) {
  const [chartInfo, setChartInfo] = useState(() => getInitialChartInfo(selectedChart));

  useViewChangeTracker('SummaryGDAGraphs', view, 'graph');

  useEffect(() => {
    setChartInfo(prevChartInfo => ({
      ...prevChartInfo,
      type: selectedChart,
    }));
  }, [selectedChart]);

  const heatmapLineSearchVariables = [
    { ident: 'score', name: 'GDA Score', fullName: 'GDA Score' },
    {
      ident: 'numPMIDsupportingAssociation',
      name: 'N. Publications',
      fullName: 'Number of Publications',
    },
    { ident: 'EI', name: 'Evidence Index', fullName: 'Evidence Index' },
  ];

  return (
    <Fragment>
      {chartInfo.type === 'HEATMAP' && (
        <HeatmapChart
          source={source}
          keySearch={keySearch}
          view={view}
          names={names}
          chartInfo={chartInfo}
          setChartInfo={setChartInfo}
          baseUrl={'api/gda/summary'}
          parent={'GDA'}
          heatmapSearchVariables={[...heatmapLineSearchVariables]}
        />
      )}

      {chartInfo.type === 'LINE' && (
        <LineChart
          source={source}
          keySearch={keySearch}
          view={view}
          names={names}
          chartInfo={chartInfo}
          setChartInfo={setChartInfo}
          baseUrl={'api/gda/summary'}
          parent={'GDA'}
          lineSearchVariables={[...heatmapLineSearchVariables]}
        />
      )}

      {chartInfo.type === 'NETWORK' && (
        <NetworkChart
          source={source}
          keySearch={keySearch}
          view={view}
          names={names}
          chartInfo={chartInfo}
          setChartInfo={setChartInfo}
          baseUrl={'api/gda/summary'}
          parent={'GDA'}
          networkSearchVariables={[...heatmapLineSearchVariables]}
        />
      )}
    </Fragment>
  );
}

export default React.memo(SummaryGDAGraphs);
